import { useEffect, useState } from 'react';
import SkuBomEditor from '../SkuBomEditor';
import type { Sku } from '../../../types';

interface BomItem {
  componentSkuId: string;
  qty: number;
  componentSku?: string;
  componentNameEn?: string;
}

interface Props {
  sku: Sku;
  onSave: (items: BomItem[]) => void;
}

export function SkuBomTab({ sku, onSave }: Props) {
  const initial: BomItem[] = (sku.bom ?? []).map((i) => ({
    componentSkuId: i.componentSkuId,
    qty: i.qty,
    componentSku: i.componentSku,
    componentNameEn: i.componentNameEn,
  }));

  const [items, setItems] = useState<BomItem[]>(initial);

  useEffect(() => {
    setItems(
      (sku.bom ?? []).map((i) => ({
        componentSkuId: i.componentSkuId,
        qty: i.qty,
        componentSku: i.componentSku,
        componentNameEn: i.componentNameEn,
      })),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sku.id]);

  if (sku.type !== 'inventory') {
    return (
      <div className="text-sm text-muted-foreground py-8 text-center">
        BOM only applies to Inventory SKUs.
      </div>
    );
  }

  return (
    <SkuBomEditor
      items={items}
      onChange={(next) => {
        setItems(next);
        onSave(next);
      }}
    />
  );
}
